'use client';

import { useState } from 'react';
import { useViewportWidthClassType } from '../shared/ViewportSizeProvider/ViewportSizeProvider';
import TruckSmarterAppUpsellBanner from './TruckSmarterAppUpsellBanner';
import TruckSmarterAppUpsellDialog from './TruckSmarterAppUpsellDialog';
import TruckSmarterAppUpsellPlatform from './TruckSmarterAppUpsellPlatform';

interface Props {
  platform: TruckSmarterAppUpsellPlatform | null;
}

export default function TruckSmarterAppUpsellProvider({ platform }: Props) {
  const viewportWidthClassType = useViewportWidthClassType();
  const [isAppUpsellDialogDismissed, setIsAppUpsellDialogDismissed] =
    useState(false);

  return platform !== null && viewportWidthClassType === 'compact' ? (
    <>
      <TruckSmarterAppUpsellBanner />
      {!isAppUpsellDialogDismissed && (
        <TruckSmarterAppUpsellDialog
          platform={platform}
          onDismiss={() => setIsAppUpsellDialogDismissed(true)}
        />
      )}
    </>
  ) : null;
}
